document.addEventListener('DOMContentLoaded', function() {
  console.log("popup-scroll")
  document.addEventListener('modal:open', lockScroll)

  document.addEventListener('modal:close', unlockScroll)


  function lockScroll() {
    scrollPosition = window.scrollY;
    document.body.classList.add('pop_open');
    document.body.style.setProperty("top", `-${scrollPosition}px`, "important");
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.body.classList.remove('pop_open');
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollPosition);
  }

  function preventScroll(e) {
    e.preventDefault();
  }
});